// extracted by mini-css-extract-plugin
export default {"item":"LandingPageListItem_item__fySMM","completed":"LandingPageListItem_completed__lgiSk","circle":"LandingPageListItem_circle__QWdUk","body":"LandingPageListItem_body__8ahod"};